import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Snowflake, Home, Sparkles, PlayCircle, User, Lock } from 'lucide-react';

const LINKS = [
  { to: '/', label: 'Home', icon: Home, testId: 'nav-home', exact: true },
  { to: '/services', label: 'Services', icon: Sparkles, testId: 'nav-services' },
  { to: '/how-it-works', label: 'How It Works', icon: PlayCircle, testId: 'nav-how' },
  { to: '/profile', label: 'My Profile', icon: User, testId: 'nav-profile' },
  { to: '/admin', label: 'Staff', icon: Lock, testId: 'nav-admin' },
];

export default function AppNav() {
  const navigate = useNavigate();

  return (
    <nav
      className="sticky top-0 z-30 border-b border-white/10 bg-slate-950/70 backdrop-blur-xl"
      data-testid="app-nav"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-6 flex items-center justify-between h-16 gap-2">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 shrink-0 group"
          data-testid="nav-brand"
        >
          <Snowflake className="w-5 h-5 text-blue-400 group-hover:rotate-45 transition-transform" strokeWidth={1.5} />
          <span className="font-display text-lg tracking-[0.15em] shimmer-text hidden sm:inline">
            KRYOTEKS
          </span>
        </button>

        <div className="flex items-center gap-0.5 sm:gap-1 overflow-x-auto no-scrollbar">
          {LINKS.map((l) => {
            const Icon = l.icon;
            return (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.exact}
                data-testid={l.testId}
                className={({ isActive }) =>
                  `inline-flex items-center gap-1.5 h-10 px-3 sm:px-4 rounded-full text-xs sm:text-sm font-semibold transition-all whitespace-nowrap ${
                    isActive
                      ? 'bg-blue-500 text-white shadow-[0_0_20px_-2px_rgba(0,168,255,0.6)]'
                      : 'text-slate-300 hover:text-white hover:bg-white/5'
                  }`
                }
              >
                <Icon className="w-4 h-4" />
                <span className="hidden sm:inline">{l.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
